import React from 'react'
import { Edit, required, SimpleForm, TextInput } from 'react-admin'

const PocEdit: React.FC = () => {
  return (
    <Edit>
      <SimpleForm>
        <TextInput disabled label="Id" source="id" />
        <TextInput source="title" validate={required()} />
      </SimpleForm>
    </Edit>
  )
}

export default PocEdit
